(ns core.front.init
  (:require [app.front.entities :as entities]
            [app.front.notifications]
            [app.front.util :as futil]
            [app.i18n.model :as i18n-model]
            [core.front.comm]
            [core.front.config :as front-config]
            [core.front.event :refer [>evt]]
            [core.front.i18n :as i18n]
            [core.front.media-query :as media-query]
            [core.front.routing :as routing]
            [day8.re-frame.async-flow-fx]
            [potpuri.core :as p]
            [re-chain.core :as rc]
            [re-frame-fx.dispatch]
            [re-frame.core-instrumented :as rf]
            [reagent.dom.client :as rdomc]
            [reitit.coercion]
            [reitit.coercion.schema :as rsc]
            [reitit.core :as re]
            [reitit.frontend.easy :as rfe]
            [schema.core :as s]))


(def default-db
  {:language            (or (futil/local-storage-get "selected-lang")
                            i18n-model/default-lang)
   :tconfig             i18n/default-tconfig
   :i18n-loaded?        false
   ::entities/entity-db {}
   :notifications       []})


(rf/reg-sub ::app-loaded?
  (fn [db _]
    (and (-> db :branding/loading? not)
         (-> db :i18n-loaded?))))


(rf/reg-event-db :i18n-loaded
  (fn [db _]
    (assoc db :i18n-loaded? true)))


(rc/configure! [{;; Is the effect in the map?
                 :effect-present? #(get % :comm/command)
                 ;;  The dispatch set for this effect in the map returned from the event handler
                 :get-dispatch    (fn [effects] (get-in effects [:comm/command :on-success]))
                 ;; Framework will call this function to insert inferred dispatch to next handler in chain
                 :set-dispatch    (fn [effects dispatch] (assoc-in effects [:comm/command :on-success] dispatch))}])


(defn boot-flow [after-login-events]
  {:first-dispatch [:core.front.session/restore-session]
   :rules          [{:when       :seen-any-of?
                     :events     [:core.front.session/restore-session.success]
                     :dispatch-n [[::entities/load-schema]
                                  [::i18n/initialize]]}
                    {:when     :seen-any-of?
                     :events   [::i18n/dict-loaded ::i18n/fail]
                     :dispatch [:i18n-loaded]
                     :halt?    true}
                    {:when       :seen?
                     :events     [:core.front.session/restored-session]
                     :dispatch-n after-login-events}]})

(rf/reg-event-fx ::boot
  (fn [{:keys [db]} [_ after-login-events]]
    {:dispatch   [::front-config/fetch-config]
     :db         (merge default-db
                        (p/assoc-if db
                                    :language (keyword (futil/local-storage-get "selected-lang"))))
     :async-flow (boot-flow after-login-events)}))

(defonce root (rdomc/create-root (.getElementById js/document "app")))

(defn init [routes root-view after-login-events]
  (when ^boolean js/goog.DEBUG
    (rf/clear-subscription-cache!)
    (s/set-fn-validation! true))
  (rf/dispatch-sync [:app.front.notifications/abort-backend-notifications])
  (rf/dispatch-sync [::boot after-login-events])
  (rf/dispatch-sync [:branding/generate-initial-css])
  (media-query/init)
  (let [router (re/router
                 routes
                 {:compile reitit.coercion/compile-request-coercers
                  :data    {:coercion rsc/coercion}})]
    (rfe/start! router
                #(>evt [::routing/on-navigate %])
                {:use-fragment false})
    (rf/dispatch [::routing/save-router router]))
  (rdomc/render root [root-view]))
